import { useMemo } from "react";
import { useQuery } from "@apollo/client/react";

import { TeamsListDataDocument } from "#app/lib/data";

/**
 * The names of the teams `userId` is the only active manager of — the teams
 * that lose their last manager when that person is suspended. `leadCount`
 * leaves suspended managers out, so a count of one on a team this person
 * leads means nobody else runs it. Pass null to skip the read.
 */
export function useSoleManagerTeams(userId: string | null): string[] {
  const variables = useMemo(
    () => ({ where: { leadIds: { hasSome: userId ? [userId] : [] } }, limit: 100 }),
    [userId],
  );
  const { data } = useQuery(TeamsListDataDocument, {
    variables,
    skip: !userId,
    fetchPolicy: "cache-and-network",
  });
  return useMemo(
    () =>
      (data?.teams.edges ?? [])
        .map((edge) => edge.node)
        .filter((team) => team.leadCount === 1)
        .map((team) => team.teamName),
    [data],
  );
}
